"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CONTEXT_KEY_LOGGER = void 0;
const ActionContext_1 = require("./ActionContext");
exports.CONTEXT_KEY_LOGGER = new ActionContext_1.ActionContextKey('@comunica/core:log');
//# sourceMappingURL=ContextEntries.js.map